import { Routes, Route, Navigate } from "react-router";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { Toaster } from "@/components/ui/sonner";
import { AppSidebar } from "./AppSidebar";
import Header from "./Header";
import Dashboard from "@/pages/Dashboard";
import DeviceLink from "@/pages/DeviceLink";
import DeviceStatus from "@/pages/DeviceStatus";
import LocationHistory from "@/pages/LocationHistory";
import ParkingHistory from "@/pages/ParkingHistory";
import ParkingLocations from "@/pages/ParkingLocations";
import UserSettings from "@/pages/UserSettings";
import { ROUTES } from "@/lib/constants";

export default function AuthenticatedApp() {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <Header />
        <main className="flex-1 p-6">
          <Routes>
            <Route
              path="/"
              element={<Navigate to={ROUTES.DASHBOARD} replace />}
            />
            <Route path={ROUTES.DASHBOARD} element={<Dashboard />} />
            <Route path={ROUTES.DEVICE_LINK} element={<DeviceLink />} />
            <Route path={ROUTES.DEVICE_STATUS} element={<DeviceStatus />} />
            <Route
              path={ROUTES.LOCATION_HISTORY}
              element={<LocationHistory />}
            />
            <Route path={ROUTES.PARKING_HISTORY} element={<ParkingHistory />} />
            <Route
              path={ROUTES.PARKING_LOCATIONS}
              element={<ParkingLocations />}
            />
            <Route path={ROUTES.USER_SETTINGS} element={<UserSettings />} />
            <Route
              path="*"
              element={<Navigate to={ROUTES.DASHBOARD} replace />}
            />
          </Routes>
        </main>
      </SidebarInset>
      <Toaster />
    </SidebarProvider>
  );
}
